import { create } from 'zustand';

/** Estado leve do shell (sidebar recolhida). Topbar dispara o toggle; a Sidebar lê a largura. */
interface ShellState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const useShellStore = create<ShellState>()((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
}));
